export var isNaturalNumber = function (value) {
    return value > 0 && Number.isInteger(value);
};
